var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.816,
    height: 13.816,
    viewBox: "0 0 13.816 13.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-play-circle",
    "data-name": "Icon ionic-ios-play-circle",
    d: "M-632.776,353.116a6.909,6.909,0,0,0-6.909,6.908,6.909,6.909,0,0,0,6.908,6.909,6.908,6.908,0,0,0,6.909-6.908h0a6.907,6.907,0,0,0-6.906-6.908Zm2.4,7.357-3.732,2.308s-.631.309-.664-.431v-4.357c0-.118-.1-.77.582-.64l3.813,2.334C-630.033,359.929-630.281,360.416-630.377,360.473Z",
    transform: "translate(639.684 -353.116)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconBlack);
export default __webpack_public_path__ + "static/media/videoIconBlack.50a52c404c1fa9245da0bcb291b1af70.svg";
export { ForwardRef as ReactComponent };